// extracted by mini-css-extract-plugin
module.exports = {"section":"TextTitle_section__Yuapp","title":"TextTitle_title__UtPOS","content":"TextTitle_content__R_ASe"};